import { Font } from '@react-pdf/renderer';
import interRegularBase64 from './inter-regular';
import interBoldBase64 from './inter-bold';

const toDataUri = (base64: string) => `data:font/ttf;base64,${base64}`;

let registered = false;

export const registerPdfFonts = () => {
  if (registered) return;
  registered = true;

  Font.register({
    family: 'Inter',
    fonts: [
      { src: toDataUri(interRegularBase64), fontWeight: 'normal' },
      { src: toDataUri(interBoldBase64), fontWeight: 'bold' },
    ],
  });
};
